import { clsx } from 'clsx';
import { type ReactNode } from 'react';
import { badgeV2, badgeV2Tones } from './badge-v2.css.ts';

export type BadgeV2Tone = keyof typeof badgeV2Tones;

export const BadgeV2 = ({
  tone,
  startIcon,
  endIcon,
  children,
  className,
  title,
}: {
  tone: BadgeV2Tone;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  children: ReactNode;
  className?: string;
  title?: string;
}) => (
  <span title={title} className={clsx(badgeV2, badgeV2Tones[tone], className)}>
    {startIcon}
    {children}
    {endIcon}
  </span>
);
